(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
    ? define(factory)
    : ((global = global || self),
      ((global.FullCalendarLocales = global.FullCalendarLocales || {}),
      (global.FullCalendarLocales.nl = factory())));
})(this, function() {
  "use strict";

  return {
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getperiodByDate: function(date, periods, routeId) {
      // console.log("periods", periods);
      var LastFoundPeriod = false;
      for (var i in periods) {
        if (
          (periods[i].startDate === null || periods[i].startDate <= date) &&
          (periods[i].stopDate === null || periods[i].stopDate >= date) // &&
          // (routeId === "" || periods[i]["route_ids"].includes(routeId))
        ) {
          if (routeId === "" || periods[i]["route_ids"].includes(routeId)) {
            LastFoundPeriod = periods[i];
          }
          // console.log("periods", periods[i].periods);
          var subPeriodsresult = this.getperiodByDate(
            date,
            periods[i].periods,
            routeId
          );
          if (
            subPeriodsresult &&
            (routeId === "" || subPeriodsresult["route_ids"].includes(routeId))
          ) {
            LastFoundPeriod = subPeriodsresult;
          }
          return LastFoundPeriod ? LastFoundPeriod : false;
        }
      }

      return false;
    },
    getperiodDayStatusByDate: function(date, period) {
      date = new Date(date);
      switch (date.getUTCDay()) {
        case 1:
          return period.monday;
        case 2:
          return period.tuesday;
        case 3:
          return period.wednesday;
        case 4:
          return period.thursday;
        case 5:
          return period.friday;
        case 6:
          return period.saturday;
        default:
          return period.sunday;
      }
    },
    getperiodDayStartStopTimesByDate: function(date, period) {
      date = new Date(date);
      switch (date.getUTCDay()) {
        case 1:
          return [
            period.mondayStartTime.substring(0, 5),
            period.mondayStopTime.substring(0, 5)
          ];
        case 2:
          return [
            period.tuesdayStartTime.substring(0, 5),
            period.tuesdayStopTime.substring(0, 5)
          ];
        case 3:
          return [
            period.wednesdayStartTime.substring(0, 5),
            period.wednesdayStopTime.substring(0, 5)
          ];
        case 4:
          return [
            period.thursdayStartTime.substring(0, 5),
            period.thursdayStopTime.substring(0, 5)
          ];
        case 5:
          return [
            period.fridayStartTime.substring(0, 5),
            period.fridayStopTime.substring(0, 5)
          ];
        case 6:
          return [
            period.saturdayStartTime.substring(0, 5),
            period.saturdayStopTime.substring(0, 5)
          ];
        case 7:
          return [
            period.sundayStartTime.substring(0, 5),
            period.sundayStopTime.substring(0, 5)
          ];
        default:
          return false;
      }
    },
    reformatLoadedShiftPeriods: function(periods) {
      // Add (sub) periods in each period
      for (var i in periods) {
        periods[i]["periods"] = [];
      }

      periods.sort(function(a, b) {
        if (a.startDate < b.startDate || a.startDate === null) {
          return -1;
        }
        if (a.startDate > b.startDate || b.startDate === null) {
          return 1;
        }
        return 0;
      });

      // find direct parents
      var foundParentIds = {};
      for (var childIndex in periods) {
        foundParentIds[periods[childIndex].id] = [];
        for (var parentIndex in periods) {
          if (
            (periods[parentIndex].startDate < periods[childIndex].startDate ||
              (periods[parentIndex].startDate === null &&
                periods[childIndex].startDate !== null)) &&
            (periods[parentIndex].stopDate > periods[childIndex].stopDate ||
              (periods[parentIndex].stopDate === null &&
                periods[childIndex].stopDate !== null))
          ) {
            foundParentIds[periods[childIndex].id].push(
              periods[parentIndex].id
            );
          }
        }
      }

      // Remove childs without parents, which are basicly the top parents
      for (childIndex in foundParentIds) {
        if (foundParentIds[childIndex].length === 0) {
          delete foundParentIds[childIndex];
        }
      }

      // Deduct direct parent from data
      // first find childs with multiple parents
      // Maybe should loop multiple times when not everyting is resolved?
      for (childIndex in foundParentIds) {
        if (foundParentIds[childIndex].length < 2) {
          continue;
        }

        // Loop though parent keys and try to find them
        for (var childParentIndex in foundParentIds[childIndex]) {
          for (var parentIndex in foundParentIds) {
            if (
              foundParentIds[childIndex][childParentIndex] === parentIndex &&
              foundParentIds[parentIndex].length === 1
            ) {
              // Found parent with single parent
              for (var childRemoveIndex in foundParentIds) {
                if (
                  !foundParentIds[childRemoveIndex].includes(parentIndex) ||
                  !foundParentIds[childRemoveIndex].includes(
                    foundParentIds[parentIndex][0]
                  )
                ) {
                  continue;
                }

                var index = foundParentIds[childRemoveIndex].indexOf(
                  foundParentIds[parentIndex][0]
                );
                if (index !== -1)
                  foundParentIds[childRemoveIndex].splice(index, 1);
              }
            }
          }
        }
      }

      // loop though child & parent relationships and find the childs that aren't parents and move them to their parents data
      while (Object.keys(foundParentIds).length > 0) {
        for (childIndex in foundParentIds) {
          var found = false;
          for (var otherChildIndex in foundParentIds) {
            if (foundParentIds[otherChildIndex].includes(childIndex)) {
              found = true;
              break;
            }
          }

          if (found) {
            continue;
          }

          // Move child to parent
          for (var childPeriodsIndex in periods) {
            if (periods[childPeriodsIndex].id === childIndex) {
              break;
            }
          }
          for (var parentPeriodsIndex in periods) {
            if (
              periods[parentPeriodsIndex].id === foundParentIds[childIndex][0]
            ) {
              break;
            }
          }

          periods[parentPeriodsIndex].periods.push(periods[childPeriodsIndex]);
          delete periods[childPeriodsIndex];
          delete foundParentIds[childIndex];
          // periods = periods.slice(0, periods.length - 1);
          // foundParentIds = foundParentIds.slice(0, foundParentIds.length - 1);

          break;
        }
      }

      var newPeriods = [];
      for (i in periods) {
        newPeriods.push(periods[i]);
      }

      return newPeriods;
    }
  };
});
